import { Box, Divider, Flex, Heading, Spacer, Text } from '@chakra-ui/react';
import React from 'react';

import { Util } from '@finley-technologies/finley-types';

import { ReportingGlobalRecurringDateConfigs } from '../../property/globalRecurringDate/ReportingGlobalRecurringDateConfigs';
import { RecurringDateConfigView } from '../../property/RecurringDateConfigView';
import { addPortfolioCovenantConfig } from './AddPortfolioCovenantModal';
import { PortfolioCovenantEditProperties } from './PortfolioCovenantEditProperties';
import { deletePortfolioCovenantConfig } from './PortfolioCovenantTable';
import { CalculationTerminologiesPopover } from '~/core/routes/calculation-terminologies/CalculationTerminologiesPopover';
import { colors } from '~/packages/common-frontend/colors';
import {
  AddTextButton,
  DeleteTextButton,
} from '~/packages/common-frontend/components/IconButton';
import {
  CreditAgreement,
  WipConfig,
} from '~/packages/creditAgreements/ui/types';

type PortfolioCovenantEditPropertiesContainerProps = {
  wipConfig: WipConfig;
  fullPropertyKey: string;
  portfolioCovenant: CreditAgreement.DomainEntity.PortfolioCovenantProperty;
  preSelectedTriggerDate: Util.FullDateStr;
};
export const PortfolioCovenantEditPropertiesContainer = ({
  wipConfig,
  fullPropertyKey,
  portfolioCovenant,
  preSelectedTriggerDate,
}: PortfolioCovenantEditPropertiesContainerProps) => {
  return (
    <Box>
      <Box mb="32px">
        <Heading as="h3" fontSize="20px" fontWeight={600} mb="24px">
          Properties
        </Heading>
        <PortfolioCovenantEditProperties
          fullPropertyKey={fullPropertyKey}
          wipConfig={wipConfig}
          portfolioCovenant={portfolioCovenant}
        />
      </Box>
      <Divider />
      {portfolioCovenant._config_ &&
      wipConfig.isMutateAllowed(fullPropertyKey) ? (
        <>
          <Flex alignItems="center" mt="32px">
            <Heading as="h3" fontSize="20px" fontWeight={600} mb="32px">
              Configurations
            </Heading>
            <Spacer />
            <DeleteTextButton
              ariaLabel="delete config"
              label="Delete Configuration"
              onClick={() => {
                deletePortfolioCovenantConfig(wipConfig, fullPropertyKey);
              }}
            />
          </Flex>

          <Box mb="64px">
            <Flex alignItems="center" mb="16px">
              <Heading as="h3" fontSize="20px" fontWeight={600} mr="8px">
                Trigger Date
              </Heading>
              <CalculationTerminologiesPopover termKeyLabel="triggerDate" />
            </Flex>

            <Text color={colors.black[70]} mb="16px">
              {`All 'Trigger Date' references in this Portfolio Covenant will
                point to this.`}
            </Text>
            <RecurringDateConfigView
              recurringDateConfig={portfolioCovenant._config_.triggerDates}
              wipConfig={wipConfig}
              fullPropertyKey={`${fullPropertyKey}._config_.triggerDates`}
              displayName="Trigger Dates"
              displayStyle="humanReadableString"
              enableEdit
            />
          </Box>
          <Box mb="64px">
            <ReportingGlobalRecurringDateConfigs
              wipConfig={wipConfig}
              globalRecurringDateConfigs={
                portfolioCovenant._config_.globalRecurringDateConfigs
              }
              basePropertyKey={`${fullPropertyKey}._config_.globalRecurringDateConfigs`}
              source="portCovs"
              preSelectedTriggerDate={preSelectedTriggerDate}
            />
          </Box>
        </>
      ) : (
        <Box mt="32px">
          {wipConfig?.isMutateAllowed(fullPropertyKey) ? (
            <Flex alignItems="center" mt="32px">
              <Heading as="h3" fontSize="20px" fontWeight={600} mb="32px">
                Configurations
              </Heading>
              <Spacer />
              <AddTextButton
                ariaLabel="add config"
                label="Add Configuration"
                onClick={() => {
                  addPortfolioCovenantConfig(wipConfig, fullPropertyKey);
                }}
              />
            </Flex>
          ) : (
            <Text>No Configuration Exists</Text>
          )}
        </Box>
      )}
    </Box>
  );
};
